export default __webpack_public_path__ + "static/media/analysis-paper.1cd8592b.svg";